export const WINDCREEK_LEGACY_URL = process.env.REACT_APP_LEGACY_URI;
export const SIGN_UP_URL = `${WINDCREEK_LEGACY_URL}/signup/wind_creek_casino/pci_gaming_gurl`;

export const TOURNAMENT_STATUS_IN_PROGRESS = 'InProgress';
export const TOURNAMENT_STATUS_UPCOMING = 'Enabled';
export const TOURNAMENT_STATUS_COMPLETED = 'Completed';

export const TOURNAMENT_LIST_BUTTON_CLASSES = {
  [TOURNAMENT_STATUS_IN_PROGRESS]: 'btn btn-success',
  [TOURNAMENT_STATUS_UPCOMING]: 'btn btn-primary',
  [TOURNAMENT_STATUS_COMPLETED]: 'btn btn-default'
};

export const GLOBAL_RESET_PASSWORD_SUCCESSFUL = 'password_reset_successful';
export const GLOBAL_RESET_PASSWORD_TOKEN_INVALID =
  'password_reset_token_invalid';
export const ERROR_DURING_FORGOT_PASSWORD = 'error_during_forgot_password';

export const GLOBAL_GAME_SESSION_IN_PROGRESS =
  'game session already in progress';

export const GLOBAL_MESSAGES = {
  [GLOBAL_RESET_PASSWORD_SUCCESSFUL]:
    'Your password has been reset. Please log in.',
  [ERROR_DURING_FORGOT_PASSWORD]:
    'Something went wrong. Please try again later.',
  [GLOBAL_RESET_PASSWORD_TOKEN_INVALID]:
    'This password reset link has expired or is invalid. Please reset your password again.',
  [GLOBAL_GAME_SESSION_IN_PROGRESS]:
    'Sorry, currently only one game session is allowed at the same time.'
};

export const ERROR_PASSWORDS_DO_NOT_MATCH = 'Passwords do not match!';
export const ERROR_PASSWORD_TOO_SHORT =
  'Password must be 8 characters or more.';
export const ERROR_PASSWORD_TOO_LONG =
  'Password cannot be more than 64 characters.';
export const ERROR_PASSWORD_MUST_CONTAIN_UNIQUE =
  'Password must contain 3 unique characters.';
export const ERROR_NO_OLD_PASSWORD = 'Please enter your previous password.';
export const ERROR_INVALID_PASSWORD = 'The password entered is incorrect.';
export const ERROR_USER_NOT_FOUND = 'User not found!';
export const ERROR_PASSWORD_IS_COMMON = 'Password must not be common.';
export const ERROR_SERVER_ERROR = 'Server Error.';
export const ERROR_INVALID_EMAIL = 'Invaid Email.';
export const SUCCESS_MESSAGE = 'Your password has been updated!';
export const SUCCESS_MESSAGE_MOBILE =
  'Your password has been updated! Please go to the app and login.';

export const REMOTE_ERRORS = {
  current_password_invalid: ERROR_INVALID_PASSWORD,
  user_not_found: ERROR_USER_NOT_FOUND,
  have_at_most_64_characters: ERROR_PASSWORD_TOO_LONG,
  have_at_least_8_characters: ERROR_PASSWORD_TOO_SHORT,
  use_at_least_$minUnique_different_characters: ERROR_PASSWORD_MUST_CONTAIN_UNIQUE,
  not_be_a_common_password: ERROR_PASSWORD_IS_COMMON
};



// WEBPACK FOOTER //
// ./src/utils/constants.js